<div class="chat-wrapper">
  <img src="../../../../assets/css/images/platform/chat-bot@3x.png" />
  <h1>{{translationsService.translate('WebGalis_ChatTitle')}}</h1>
  <h2>{{translationsService.translate('WebGalis_ChatText')}}</h2>

  <div class="chat-usergpt-inout">

    @for (chatItem of chatItems; track chatItem) {
      <div>
        @if (chatItem.itemFunctionalType == 0) {
          <div class="liner-block user-input-item">
            @if (chatItem.itemType==1) {
              <img src="../../../../assets/css/images/platform/wand@3x.png" />
            }
            @if (chatItem.itemType==0) {
              <img src="../../../../assets/css/images/platform/chat-userinput@3x.png" />
            }
            <p>{{chatItem.text}}</p>
          </div>
        }
        @if (chatItem.itemFunctionalType == 1) {
          <div class="liner-block confirmation">
            <div class="liner-inline">
              <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />
              <div class="side-con">
                <p>V {{chatItem.response.ParsedCommand.Parameters["type"].PrettyName}}
                  @if (chatItem.response.ParsedCommand.Action=='add') {
                    <span> bom dodal naslednji
                    zapis:</span>
                  }
                  @if (chatItem.response.ParsedCommand.Action=='search') {
                    <span> bom naredil iskanje
                    po:</span>
                  }
                </p>
                @for (par of chatItem.response.ParsedCommand.Parameters | keyvalue; track par) {
                  @if (par.key!='type') {
                    <p class="parameter-izpis">
                      {{chatItem.response.ParsedCommand.Parameters[par.key].PrettyName}}:
                      @for (va of chatItem.response.ParsedCommand.Parameters[par.key].Values; track va) {
                        <span>
                          {{va}}
                        </span>
                      }
                    </p>
                  }
                }
                <p></p>
                <p>Želite potrditi to dejanje?</p>
                <div class="liner-inline">
                  <button (click)="confirmDetectedCommand(chatItem, true); $event.preventDefault();">Potrdi</button>
                  <!--  <button (click)="cancelDetectedCommand(chatItem); $event.preventDefault();">Prekliči</button> -->
                </div>
              </div>
            </div>
          </div>
        }
        @if (chatItem.itemFunctionalType == 3) {
          <div class="liner-block confirmation redirect">
            <div class="liner-inline">
              <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />
              <div class="side-con">
                <p>{{chatItem.text}}</p>
                <div class="liner-inline">
                  <a class="button" href="{{chatItem.redirectUrl}}" target="_blank">Odpri</a>
                  <!--<button (click)="redirectToAddedRecord(chatItem); $event.preventDefault();">Odpri</button>-->
                </div>
              </div>
            </div>
          </div>
        }
        @if (chatItem.itemFunctionalType == 4) {
          <div class="liner-block confirmation redirect media-container">
            <div class="liner-inline">
              <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />
              <div class="side-con">
                <p>{{chatItem.text}}</p>
                <div class="inline-imgs">
                  <ul>
                    @for (model of chatItem.response.ExecutionResponseData.Models; track model) {
                      <li>
                        <a href="/cms/galisweb/item?id={{model.Model.Id}}" target="_blank">
                          <sem-image-viewer [mediaId]="model.Model.FirstMediaId" [height]="84"
                          [width]="115"></sem-image-viewer>
                          <div class="pretty-inv">{{model.Model.PrettyInvNum}}</div>
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        }
        @if (chatItem.itemFunctionalType == 99) {
          <div class="liner-block confirmation-error">
            <div class="liner-inline">
              <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />
              <div class="side-con">
                <p>{{chatItem.text}}</p>
              </div>
            </div>
          </div>
        }
      </div>
    }

    <!--div class="chat-loader" *ngIf="isChatLoading">
    <img src="/assets/css/images/platform/loader.gif" />
  </div-->
  @if (isChatLoading) {
    <div class="chat-loader">
      <sem-loader [showLoader]="true"></sem-loader>
    </div>
  }

</div>

<div class="chat-user-input">
  <div class="liner-block">
    <img src="../../../../assets/css/images/platform/chat-userinput@3x.png" />
    <input (keydown.enter)="sendUserInput($event); $event.preventDefault();" type="text" [(ngModel)]="userInput"
      placeholder="Kako lahko pomagam?" />
    </div>

  </div>
</div>


<!--
<div class="liner-block confirmation">
  <div class="liner-inline">
    <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />


    <div class="side-con">
      <p>Avtor Janez Novak ne obstaja, ga dodam?</p>
      <p>Želite potrditi to dejanje?</p>

      <div class="liner-inline">
        <button>Potrdi</button>
        <button>Prekliči</button>
      </div>
    </div>
  </div>

</div>

<div class="liner-block confirmation-error">
  <div class="liner-inline">
    <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />


    <div class="side-con">
      <p>Avtor Janez Novak ne obstaja, ga dodam?</p>
      <p>Želite potrditi to dejanje?</p>

      <div class="liner-inline">
        <button>Potrdi</button>
        <button>Prekliči</button>
      </div>
    </div>
  </div>

</div>

<div class="liner-block confirmation redirect">
  <div class="liner-inline">
    <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />


    <div class="side-con">
      <p>Dodan je bil avtor Janez Novak.</p>

      <div class="liner-inline">
        <button>Odpri</button>
      </div>
    </div>
  </div>

</div>


<div class="liner-block confirmation">
  <div class="liner-inline">
    <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />


    <div class="side-con">
      <p>Avtor Janez Novak ne obstaja, ga dodam?</p>
      <p>Želite potrditi to dejanje?</p>

      <div class="liner-inline">
        <button>Potrdi</button>
        <button>Prekliči</button>
      </div>
    </div>
  </div>

</div>



<div class="liner-block confirmation redirect">
  <div class="liner-inline">
    <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />


    <div class="side-con">
      <p>Dodan je bil avtor Janez Novak.</p>

      <div class="liner-inline">
        <button>Odpri</button>
      </div>
    </div>
  </div>

</div>

<div class="liner-block affirmation">
  <img src="../../../../assets/css/images/platform/wand@3x.png" />
  <p>Poišči vse zapise v Inventarni knjigi, ki jih je izdelal Janez Novak med letoma 1970 in 1980.</p>
  <img src="../../../../assets/css/images/platform/autorenew@3x.png" />
</div>

<div class="liner-block confirmation redirect media-container">
  <div class="liner-inline">
    <img class="icon" src="../../../../assets/css/images/platform/wand@3x.png" />


    <div class="side-con">
      <p>V Inventarni knjigi je 11 predmetov, ki jih je izdelal Janez Novak med letoma 1970 in 1980.</p>

      <div class="inline-imgs">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div> -->